"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styled = exports.ThemeProvider = exports.keyframes = exports.css = exports.theme = exports.colorNames = void 0;
const styledComponents = __importStar(require("styled-components"));
//PRIMARY
const BLUE_1 = '#0091EA';
const GRAY_1 = '#333333';
const WHITE = '#FFFFFF';
//SECONDARY
const RED_1 = '#EF3824';
const ORANGE_1 = '#FF9000';
const YELLOW_1 = '#F7B500';
const GREEN_1 = '#72BF44';
//NEUTRAL PALETTE
const GRAY_2 = '#666666';
const GRAY_3 = '#999999';
const GRAY_4 = '#CCCCCC';
const GRAY_5 = '#EEEEEE';
const GRAY_6 = '#F9F9F9';
const BACKGROUND = '#F3F6F7';
//BLUE
const LIGHT_BLUE = '#EAF7FF';
const BLUE_2 = '#007CC8';
const BLUE_3 = '#005C95';
//RED
const LIGHT_RED = '#FFF0F0';
const RED_3 = '#B90000';
const SUPPORT_BRIGHT_RED = '#FF0000';
//YELLOW
const SUPPORT_DARK_YELLOW = '#FFC418';
//ORANGE
const ORANGE_2 = '#FF7200';
//GREEN
const LIGHT_GREEN = '#EAF6E3';
const UI_BLACK = '#000000';
const primary = {
    blue: BLUE_1,
    gray: GRAY_1,
    white: WHITE,
};
const secondary = {
    red: RED_1,
    orange: ORANGE_1,
    yellow: YELLOW_1,
    green: GREEN_1,
};
const neutral = {
    white: WHITE,
    background: BACKGROUND,
    gray6: GRAY_6,
    gray5: GRAY_5,
    gray4: GRAY_4,
    gray3: GRAY_3,
    gray2: GRAY_2,
    gray: GRAY_1,
};
const blue = {
    lightBlue: LIGHT_BLUE,
    blue: BLUE_1,
    blue2: BLUE_2,
    blue3: BLUE_3,
};
const red = {
    lightRed: LIGHT_RED,
    red: RED_1,
    red3: RED_3,
};
const orange = {
    orange: ORANGE_1,
    orange2: ORANGE_2,
};
const green = {
    lightGreen: LIGHT_GREEN,
    green: GREEN_1,
};
const extendedColors = Object.assign(Object.assign(Object.assign(Object.assign({}, blue), red), orange), green);
const depricated = {
    brightRed: SUPPORT_BRIGHT_RED,
    uiBlack: UI_BLACK,
    darkYellow: SUPPORT_DARK_YELLOW,
};
exports.colorNames = [
    ...Object.keys(primary),
    ...Object.keys(secondary),
    ...Object.keys(neutral),
    ...Object.keys(blue),
    ...Object.keys(red),
    ...Object.keys(orange),
    ...Object.keys(green),
];
exports.theme = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, primary), secondary), neutral), extendedColors), depricated), { font: {
        family: {
            /**
             * 'proxima-nova, arial, sans-serif'
             */
            proximaNova: 'proxima-nova, arial, sans-serif',
        },
        weight: {
            /**
             * 300
             */
            light: 300,
            /**
             * 400
             */
            regular: 400,
            /**
             * 600
             */
            medium: 600,
            /**
             * 800
             */
            semiBold: 800,
            /**
             * 900
             */
            bold: 900,
        },
        size: {
            /**
             * 12px
             */
            xxsmall: '12px',
            /**
             * 14px
             */
            xsmall: '14px',
            /**
             * 16px
             */
            small: '16px',
            /**
             * 18px
             */
            medium: '18px',
            /**
             * 24px
             */
            large: '24px',
            /**
             * 36px
             */
            xlarge: '36px',
            /**
             * 48px
             */
            xxlarge: '48px',
        },
    }, colors: {
        /**
         * #F3F6F7
         */
        background: '#F3F6F7',
        /**
         * #000000
         */
        black: '#000000',
        gray: {
            /**
             * #F9F9F9
             */
            10: '#F9F9F9',
            /**
             * #EEEEEE
             */
            20: '#EEEEEE',
            /**
             * #CCCCCC
             */
            30: '#CCCCCC',
            /**
             * #BBBBBB
             */
            40: '#BBBBBB',
            /**
             * #999999
             */
            50: '#999999',
            /**
             * #888888
             */
            60: '#888888',
            /**
             * #666666
             */
            70: '#666666',
            /**
             * #444444
             */
            80: '#444444',
            /**
             * #333333
             */
            90: '#333333',
        },
        blue: {
            /**
             * #EAF7FF
             */
            10: '#EAF7FF',
            /**
             * #62C3FF
             */
            30: '#62C3FF',
            /**
             * #0091EA
             */
            50: '#0091EA',
            /**
             * #005C95
             */
            70: '#005C95',
            /**
             * #003251
             */
            90: '#003251',
        },
        green: {
            /**
             * #EAF6E3
             */
            10: '#EAF6E3',
            /**
             * #B5DD9D
             */
            30: '#B5DD9D',
            /**
             * #72BF44
             */
            50: '#72BF44',
            /**
             * #457528
             */
            70: '#457528',
            /**
             * #274217
             */
            90: '#274217',
        },
        red: {
            /**
             * #FFF0F0
             */
            10: '#FFF0F0',
            /**
             * #F68E83
             */
            30: '#F68E83',
            /**
             * #EF3824
             */
            50: '#EF3824',
            /**
             * #A11B0C
             */
            70: '#A11B0C',
            /**
             * #520E06
             */
            90: '#520E06',
        },
        orange: {
            /**
             * #FFF0DB
             */
            10: '#FFF0DB',
            /**
             * #FFCA85
             */
            30: '#FFCA85',
            /**
             * #FF9000
             */
            50: '#FF9000',
            /**
             * #CC5F00
             */
            70: '#CC5F00',
        },
        yellow: {
            /**
             * #FFEFC4
             */
            10: '#FFEFC4',
            /**
             * #FFD86F
             */
            30: '#FFD86F',
            /**
             * #F7B500
             */
            50: '#F7B500',
            /**
             * #C28100
             */
            70: '#C28100',
        },
    } });
const { default: styled, css, keyframes, ThemeProvider, } = styledComponents;
exports.styled = styled;
exports.css = css;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.default = exports.theme;
//# sourceMappingURL=Theme.js.map